interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-0',
    question: 'O que é o Open Finance?',
    answer:
      'O Open Finance é uma iniciativa do Banco Central do Brasil que permite que você, como cliente, compartilhe seus dados financeiros de forma segura entre instituições autorizadas.\n\nCom o seu consentimento, sistemas como o Pierre podem acessar informações bancárias (como contas, cartões e investimentos) para oferecer uma visão completa e personalizada das suas finanças.\n\nTodo o processo é protegido por padrões rigorosos de segurança e criptografia, e você tem o controle total para decidir o que compartilhar, com quem e por quanto tempo.',
  },
  {
    id: 'faq-1',
    question: 'Posso conectar mais de um banco?',
    answer:
      'Sim! Você pode conectar quantos bancos quiser ao Pierre. Quanto mais contas conectadas, mais completa será sua visão financeira e mais precisos serão os insights personalizados que o Pierre pode te oferecer.',
  },
  {
    id: 'faq-2',
    question: 'Como eu me conecto com os bancos?',
    answer:
      'A conexão é feita de forma segura via Open Finance, diretamente pelo Pierre. Durante o processo, você será redirecionado para o ambiente seguro do seu banco para autorizar o compartilhamento de dados. O processo leva menos de 1 minuto.',
  },
  {
    id: 'faq-3',
    question: 'Preciso fornecer minhas senhas bancárias ao Pierre?',
    answer:
      'Não. Você nunca fornece sua senha bancária ao Pierre. A autorização acontece no próprio site do seu banco, com toda a segurança e criptografia exigida pelo Banco Central.',
  },
  {
    id: 'faq-4',
    question: 'O Pierre consegue efetuar transações e pagamentos?',
    answer:
      'Não. O Pierre não tem permissão para movimentar dinheiro ou fazer transações na sua conta. Ele apenas lê seus dados financeiros autorizados para ajudar você a entender melhor sua vida financeira.',
  },

  {
    id: 'faq-5',
    question: 'Preciso configurar ou instalar algo no app do meu banco?',
    answer:
      'Não. O Pierre usa o Open Finance, uma tecnologia autorizada pelo Banco Central, que permite integração segura sem necessidade de instalar nada nos apps dos bancos. Você só precisa autorizar o acesso aos seus dados financeiros uma vez, e o Pierre fará o resto automaticamente.',
  },
  {
    id: 'faq-6',
    question: 'Preciso adicionar os meus gastos e transações manualmente?',
    answer:
      'Não. O Pierre automaticamente categoriza e registra suas transações assim que você conecta suas contas bancárias. Você não precisa adicionar nada manualmente.',
  },
  {
    id: 'faq-7',
    question:
      'Posso fornecer apenas uma conta ou apenas um cartão da minha instituição financeira?',
    answer:
      'Sim! Ao se conectar via Open Finance, você pode escolher exatamente quais contas, cartões ou produtos financeiros deseja compartilhar com o Pierre. A autorização é totalmente personalizada e você tem o controle total sobre quais informações serão acessadas.',
  },
  {
    id: 'faq-8',
    question: 'A conexão do meu banco está demorando. O que devo fazer?',
    answer:
      'A conexão via Open Finance pode levar alguns minutos dependendo do banco. Assim que o processo for concluído, o Pierre avisará você diretamente no app. Nesse período, não é necessário repetir a operação. Basta aguardar a confirmação.',
  },
  {
    id: 'faq-9',
    question:
      'Conectei minha conta, mas meus saldos ou transações não aparecem no chat. Isso é normal?',
    answer:
      'Sim, pode acontecer! Após a conexão, os dados podem levar até 10 minutos para aparecerem no chat. Caso não atualize automaticamente, tente reconectar sua instituição bancária após esse intervalo. Essa sincronização depende dos próprios bancos, e alguns enviam informações com leve atraso.',
  },
];
